import { useEffect, useState } from "react";

export default function ImagesLoaded({ setNumImagesLoaded, setNumberOfImages }) {

  useEffect(() => {
    const images = Array.from(document.getElementsByTagName("img"));

    setNumberOfImages(images.length);

    // console.log("number of images:" + images.length);
    // console.log(images);

    images.forEach((img) => {
      img.addEventListener("load", incrementImagesLoaded);
    });
  }, []);



  const incrementImagesLoaded = () => {
    setNumImagesLoaded((number) => {
      return number + 1;
    });
  }
  return null;
}
